module.exports = __webpack_public_path__ + "img/singletrack-promo-left.2f63835a.png";